import React from 'react';
import { Hero } from '../components/Hero';
import { ServicesSection } from '../components/ServicesSection';
import { HomeFleetPreview } from '../components/HomeFleetPreview';
import { HowItWorks } from '../components/HowItWorks';
import type { TripSearch } from '../types/search';
interface HomePageProps {
  onSearch: (search: TripSearch) => void;
}
export function HomePage({
  onSearch
}: HomePageProps) {
  return <main data-id="element-398" data-mp="2x1k72du55ac1">
      <Hero onSearch={onSearch} data-id="element-399" data-mp="2x1adkg9w0l1l" />
      <ServicesSection data-id="element-400" data-mp="2wy62r01x2r1y" />
      <HomeFleetPreview data-id="element-401" data-mp="2s1xum6m4zy4a" />
      <HowItWorks data-id="element-402" data-mp="2s2h0uq2fcy2h" />
    </main>;
}